/**
 * CardAsync ActionTypes
 */
export enum Actions {
  SET_SHOW_LANGUAGE_MODAL = "SET_SHOW_LANGUAGE_MODAL",
}



// WEBPACK FOOTER //
// ./src/store/helpers/Actions.ts